/* eslint-disable */
import { useSnackbarStore } from '../stores/snackbar'
import { useLoaderStore } from '../stores/loader'
import { useEmptyStateStore } from '../stores/emptyState'
// let zohoConnectionName = store.getters.getConnectionName;

export default {
    updateStateObject: (objectData) => {
      const emptyStateStore = useEmptyStateStore()
      emptyStateStore.updateEmptyState(objectData)
    },
    updateAppLoader: (newState) => {
      const loaderStore = useLoaderStore()
      loaderStore.updateLoader(newState)
    },  
    triggerSnackbar(content, color, bgColor, icon, duration){
      const snackbarStore = useSnackbarStore()
      snackbarStore.updateSnackbar({
        active: true,
        content,
        color,
        bgColor,
        icon,
        duration
      })
    },
    closeSnackbar(){
      const snackbarStore = useSnackbarStore()
      snackbarStore.closeSnackbar()
    }
  }